/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import React, { useState } from 'react';
import { ArrowLeft, Trophy } from 'lucide-react';
import { Leaderboard } from '../components/Leaderboard';
import { QuantumScene } from '../components/QuantumScene';
import { WalletAnalysisPopup } from '../components/WalletAnalysisPopup';

interface RankingPageProps {
    onBack: () => void;
}

export const RankingPage: React.FC<RankingPageProps> = ({ onBack }) => {
    const [analyzingWallet, setAnalyzingWallet] = useState<string | null>(null);

    return (
        <div className="min-h-screen bg-[#F9F8F4] flex flex-col relative animate-fade-in">
            {analyzingWallet && (
                <WalletAnalysisPopup 
                    walletAddress={analyzingWallet} 
                    onClose={() => setAnalyzingWallet(null)} 
                />
            )}
            
            <main className="flex-1 pb-24">
                
                {/* Hero Section */}
                <section className="relative py-24 md:py-32 overflow-hidden bg-stone-900 text-white">
                    <div className="absolute inset-0 z-0 opacity-20">
                        <QuantumScene />
                    </div>
                    <div className="container mx-auto px-6 relative z-10">
                        <div className="text-center max-w-3xl mx-auto pt-8">
                            <div className="inline-flex items-center gap-2 px-3 py-1 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full mb-6">
                                <Trophy size={12} className="text-nobel-gold" />
                                <span className="text-[10px] font-bold text-stone-200 uppercase tracking-widest">Community Rankings</span>
                            </div>
                            <h1 className="font-serif text-4xl md:text-6xl text-white mb-6 leading-tight">
                                Top Traders & Creators
                            </h1>
                            <p className="text-xl text-stone-300 leading-relaxed max-w-2xl mx-auto">
                                Discover the most influential players in The Foundry ecosystem, ranked by volume, launches, and overall impact.
                            </p>
                        </div>
                    </div>
                </section>

                <section className="py-16">
                    <Leaderboard onAnalyzeWallet={setAnalyzingWallet} />
                </section>
            </main>
        </div>
    );
};